import type { Color, PieceSymbol, Square, Piece } from 'chess.js';

export type { Color, PieceSymbol, Square, Piece };

export type TPlayerSlot = 0 | 1;

export const WHITE_SLOT: TPlayerSlot = 0;
export const BLACK_SLOT: TPlayerSlot = 1;

export function colorToSlot(c: Color): TPlayerSlot {
  return c === 'w' ? 0 : 1;
}

export function slotToColor(s: TPlayerSlot): Color {
  return s === 0 ? 'w' : 'b';
}

export type TSquare = Piece | null;

export type TBoard = TSquare[][];

export type TGameStatus =
  | 'idle'
  | 'playing'
  | 'finished'
  | 'draw'
  | 'checkmate'
  | 'stalemate'
  | 'timeout';

export interface IRowCol {
  row: number;
  col: number;
}

export interface IMove {
  from: Square;
  to: Square;
  promotion?: PieceSymbol;
}

export interface ICastlingRights {
  whiteKingside: boolean;
  whiteQueenside: boolean;
  blackKingside: boolean;
  blackQueenside: boolean;
}

export const DEFAULT_CASTLING_RIGHTS: ICastlingRights = {
  whiteKingside: true,
  whiteQueenside: true,
  blackKingside: true,
  blackQueenside: true,
};

export interface IChessState {
  board: TBoard;
  currentTurn: Color;
  status: TGameStatus;
  winner: Color | null;
  whiteTimeMs: number;
  blackTimeMs: number;
  turnDurationMs: number;
  lastMove: IMove | null;
  moveCount: number;
  castlingRights: ICastlingRights;
  enPassantTarget?: Square | null;
}

export type TMoveError =
  | 'not_playing'
  | 'not_your_turn'
  | 'invalid_move'
  | 'no_piece'
  | 'would_expose_king'
  | null;

export interface IMoveResult {
  success: boolean;
  error: TMoveError;
  gameState: IChessState;
  isGameOver: boolean;
  winner: Color | null;
  isDraw: boolean;
}
